import { defineMessages } from "react-intl";

export const messages = defineMessages({
    socialSignUpButtonContinueWithGoogle: {
        id: `WacSignupForm.socialSignUpButtonContinueWithGoogle`,
        defaultMessage: "Continue with Google"
    },
    socialSignUpButtonContinueWithMicrosoft: {
        id: `WacSignupForm.socialSignUpButtonContinueWithMicrosoft`,
        defaultMessage: "Continue with Microsoft"
    },
    socialSignUpButtonSignUpWithEmail: {
        id: `WacSignupForm.socialSignUpButtonSignUpWithEmail`,
        defaultMessage: "Sign up with email"
    },
    socialSignUpButtonSignUpWithGoogle: {
        id: `WacSignupForm.socialSignUpButtonSignUpWithGoogle`,
        defaultMessage: "Sign up with Google"
    }
});
